import { translateUGC } from '../../utils/ugc/translate';

export const TOGGLE_UGC_VIEW = 'TOGGLE_UGC_VIEW';
export const toggleUGCView = () => ({
    type: TOGGLE_UGC_VIEW
});

export const FETCH_UGC = 'FETCH_UGC';
export const fetchUGC = ({ sourceInfo, shouldToggle = true }) => async(dispatch, getState) => {
    const { ugc } = getState();
    const { ugcMap } = ugc;

    const translatedUGC = await translateUGC({
        content: ugcMap.original,
        sourceInfo
    });

    dispatch({
        type: FETCH_UGC,
        data: {
            translatedUGC,
            shouldToggle
        }
    });
};

export const UGC_UPDATED = 'UGC_UPDATED';
export const ugcUpdated = () => (dispatch, getState) => {
    const { ugc } = getState();

    dispatch({
        type: UGC_UPDATED,
        data: {
            ugc
        }
    });
};

export const UPDATE_LISTINGS_UGC = 'UPDATE_LISTINGS_UGC';
export const updateListingsUGC = (listingsUGC, carouselType) => ({
    type: UPDATE_LISTINGS_UGC,
    data: {
        listingsUGC,
        carouselType
    }
});

export const UPDATE_PERSONALIZATION_UGC = 'UPDATE_PERSONALIZATION_UGC';

/**
 * Update Personalization UGC data
 * @param {object} personalizationUGC data
 * @param {string} sectionName
 * @return {object} update data action object
 * **/
export const updatePersonalizationUGC = (personalizationUGC, sectionName) => ({
    type: UPDATE_PERSONALIZATION_UGC,
    data: {
        personalizationUGC,
        sectionName
    }
});

export const UPDATE_GALLERY_REVIEWS_UGC = 'UPDATE_GALLERY_REVIEWS_UGC';
export const updateGalleryReviewsUGC = (review) => ({
    type: UPDATE_GALLERY_REVIEWS_UGC,
    data: {
        review
    }
});
